import React from "react";

const CountryIcon = (props) => {
  const { width, height } = props;

  return (
    <svg
      width={width || "24"}
      height={height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.75 6.5C5.75 6.08579 5.41421 5.75 5 5.75C4.58579 5.75 4.25 6.08579 4.25 6.5H5.75ZM4.25 21C4.25 21.4142 4.58579 21.75 5 21.75C5.41421 21.75 5.75 21.4142 5.75 21H4.25ZM4.25 6.5V21H5.75V6.5H4.25Z"
        fill="#1D1D1D"
        fillOpacity="0.866667"
      />
      <path
        d="M9.89276 4.03716L9.61555 4.73405L9.89276 4.03716ZM13.1087 5.31643L12.8315 6.01331L13.1087 5.31643ZM13.1087 12.7744L13.3859 13.4713L13.1087 12.7744ZM5 16H4.25C4.25 16.2486 4.3732 16.4811 4.57894 16.6206C4.78467 16.7602 5.04621 16.7888 5.27721 16.6969L5 16ZM5.78983 3.19461L5.40309 2.55202L5.40309 2.55202L5.78983 3.19461ZM9.61555 4.73405L12.8315 6.01331L13.3859 4.61954L10.17 3.34027L9.61555 4.73405ZM12.8315 12.0776L4.72279 15.3031L5.27721 16.6969L13.3859 13.4713L12.8315 12.0776ZM12.8315 6.01331C14.819 6.80393 16.2299 7.36723 17.1537 7.89764C18.1016 8.44187 18.25 8.79072 18.25 9.04544H19.75C19.75 7.91463 18.9165 7.18014 17.9006 6.59682C16.8607 5.99969 15.3259 5.39125 13.3859 4.61954L12.8315 6.01331ZM13.3859 13.4713C15.3259 12.6996 16.8607 12.0912 17.9006 11.4941C18.9165 10.9107 19.75 10.1762 19.75 9.04544H18.25C18.25 9.30015 18.1016 9.649 17.1537 10.1932C16.2299 10.7236 14.819 11.2869 12.8315 12.0776L13.3859 13.4713ZM4.25 6.98188V16H5.75V6.98188H4.25ZM10.17 3.34027C9.08688 2.90943 8.20161 2.55543 7.48848 2.37989C6.76562 2.20194 6.05088 2.16214 5.40309 2.55202L6.17658 3.83721C6.31863 3.75172 6.55098 3.69389 7.12994 3.8364C7.71863 3.98132 8.48991 4.28628 9.61555 4.73405L10.17 3.34027ZM5.75 6.98188C5.75 5.85093 5.75234 5.09561 5.83914 4.55809C5.92163 4.04722 6.0532 3.91146 6.17658 3.83721L5.40309 2.55202C4.73663 2.95312 4.47328 3.60703 4.35832 4.31897C4.24766 5.00426 4.25 5.90489 4.25 6.98188H5.75Z"
        fill="#1D1D1D"
        fillOpacity="0.866667"
      />
    </svg>
  );
};

export default CountryIcon;
